import {
  PlacementInstructionConfig,
  InitialState,
  debugLog,
  UNLEASH_FEATURE_NAME
} from '@schibsted-nmp/advertising-shared';
import { advtPerformance } from '@schibsted-nmp/advertising-events';

import { initiate as initiateAdnamiOverlapScrollEvent } from './utils/dom/handleAdnamiOverlap';
import { setupEvents } from './utils/events';
import { setPageOptsInXandr } from './xandr/setPageOpts';
import { defineAdvtComponent } from './components/web-components';
import { setupOverrideHelper } from './utils/overrideHelper';
import { isFeatureEnabled } from './state/reducer';

/**
 * Initiates ad rendering, setup page options and handles each placement.
 * @param initialState The initial state for setting up ads.
 */
export async function initiateAdvt(initialState: InitialState): Promise<void> {
  advtPerformance.markXandrEvents(`initiateAdvt`);
  advtPerformance.markXandrEvents(
    `Expect placements: ${initialState?.config?.xandr?.placements
      ?.map((p) => p.placementId)
      .join(', ')}`
  );

  debugLog('Inside initiateAdvt()');

  const { config, env } = initialState;

  if (env === 'local') {
    debugLog('Rendering dev panel');
    const { renderDevPanel } = await import('./local');
    renderDevPanel();
  }
  debugLog('Going to set page opts in xandr');
  await setPageOptsInXandr(config);

  const placementInstructionConfigs =
    getPlacementInstructionIfConfigExists(config);
  debugLog('placementInstructionConfigs:', placementInstructionConfigs);

  debugLog('Setting up events');

  const isAfsEnabled = isFeatureEnabled(
    UNLEASH_FEATURE_NAME.enableAfsPlacements
  );

  setupEvents({
    placementInstructionConfigs,
    pageType: config.pageType,
    afs: config.afs
  });

  defineAdvtComponent();

  if (config?.xandr?.placements) {
    setupOverrideHelper(config.xandr.placements);
  }

  const isResultPage = config.pageType === 'result';

  debugLog('isResultPage:', isResultPage);
  debugLog('config.afs:', config.afs);
  debugLog('isAfsEnabled:', isAfsEnabled);
  if (isResultPage && config.afs && isAfsEnabled) {
    debugLog('Triggering all AFS placements');
  }

  if (config.deviceType === 'desktop') {
    initiateAdnamiOverlapScrollEvent();
  }
}

/**
 * Checks if placement instructions are available in the config.
 * If so, sets up a listener for each placement.
 * Returns the placement instructions.
 * @param config
 */
export function getPlacementInstructionIfConfigExists(
  config
): PlacementInstructionConfig[] {
  const placementInstructions = config?.xandr?.placementInstructions || [];

  const placementInstructionAvailable = Boolean(
    placementInstructions.length && placementInstructions[0]?.data
  );

  return placementInstructionAvailable ? placementInstructions : [];
}
